// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const cadastrarCotaUsuarioService = async (data: CotaUsuario) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario`;
    try {
      const response = await axios.post(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
